import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { EntityWarningContent } from './EntityWarningContent';
import { techdocsContent } from './TechdocsContent';

const MinimalOverviewContent = () => (
  <Grid container spacing={3} alignItems="stretch">
    <EntityWarningContent />
    <Grid item md={6} xs={12}>
      <Grid container>
        <Grid item xs={12}>
          <EntityAboutCard />
        </Grid>
        <Grid item xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item xs={12}>
          <EntityMarkdownCard />
        </Grid>
      </Grid>
    </Grid>
    <Grid item md={6} xs={12}>
      <Grid container>
        <Grid item xs={12}>
          <EntityCatalogGraphCard height={200} />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export const DefaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <MinimalOverviewContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
